import {Gear} from './gear.model';

/**
 * Extension from the Gear class
 */
export class PotGear extends Gear {

    potHeight!: number;

    potWidth!: number;

    potLength!: number;

    spacing!: number;

    escapeHoleSize!: number;
    
    escapeHoleCount!: number;


    //Expected parameter is an anonymous object with all the same fields as this Gear class
    static transformAnonymous(anon: any): PotGear {
        let pot = new PotGear();
        pot.gearID = anon.gearID;
        pot.fishingEventID = anon.fishingEventID;
        pot.identifier = anon.identifier;
        pot.type = anon.type;
        pot.gearSubtype = anon.gearSubtype;
        pot.potHeight = anon.potHeight;
        pot.potWidth = anon.potWidth;
        pot.potLength = anon.potLength;
        pot.spacing = anon.spacing;
        pot.escapeHoleSize = anon.escapeHoleSize;
        pot.escapeHoleCount = anon.escapeHoleCount;
        pot.fishery = 'Groundfish';
        return pot;
    }


    constructor() {
        super();
        this.type = "Pot";
    }


    isEqual(cmp: PotGear) {
        return this.identifier == cmp.identifier &&
        this.potHeight == cmp.potHeight &&
        this.potWidth == cmp.potWidth &&   
        this.potLength == cmp.potLength &&      
        this.spacing == cmp.spacing &&       
        this.escapeHoleSize == cmp.escapeHoleSize &&           
        this.escapeHoleCount == cmp.escapeHoleCount &&
        this.gearSubtype.id == cmp.gearSubtype.id &&
        this.gearSubtype.lookupType == cmp.gearSubtype.lookupType;
    }


    toString() {
        if (this.identifier == '')
            return '';
        return this.identifier + " -- Pot - " + this.gearSubtype.name + " -- " + this.spacing + " ft -- " + "Hole Size: " + this.escapeHoleSize + " -- Hole Count: " + this.escapeHoleCount;
    }
}